import { mergeStyles } from '@cian/utils';
import * as React from 'react';
import { IProject } from '../../types';
import { getNextSlidePosition } from '../../utils/getNextSlidePosition';
import { shouldRenderSliderArrows } from '../../utils/shouldRenderSliderArrows';
import { trackProjectListItemClick } from '../../utils/tracking/project';
import { ArrowButton } from '../ArrowButton';
import { ProjectPreview } from './ProjectPreview';
import * as styles from './ProjectList.css';

export interface IProjectListProps {
  list: IProject[];
}

export interface IProjectListState {
  scrollLeft: number;
  currentIndex: number;
  isLast?: boolean;
}

const DEFAULT_STATE: IProjectListState = {
  scrollLeft: 0,
  currentIndex: 0,
  isLast: false,
};

export class ProjectList extends React.PureComponent<IProjectListProps, IProjectListState> {
  public listRef = React.createRef<HTMLDivElement>();
  public state = DEFAULT_STATE;

  public componentDidMount() {
    this.refreshState();

    window.addEventListener('resize', this.refreshState);
  }

  public componentWillUnmount() {
    window.removeEventListener('resize', this.refreshState);
  }

  public render() {
    const { list } = this.props;
    const { scrollLeft, currentIndex, isLast } = this.state;

    return (
      <div className={styles['container']}>
        <div className={styles['inner_container']}>
          <div {...mergeStyles(styles['list'], { transform: `translateX(-${scrollLeft}px)` })} ref={this.listRef}>
            {list.map(project => (
              <ProjectPreview
                key={project.id}
                project={project}
                onClick={() => trackProjectListItemClick(project.id)}
              />
            ))}
          </div>
          {!!currentIndex && (
            <div className={styles['left_button']}>
              <ArrowButton direction="left" onClick={this.onNavigationButtonClick('left')} />
            </div>
          )}
          {!isLast && (
            <div className={styles['right_button']}>
              <ArrowButton direction="right" onClick={this.onNavigationButtonClick('right')} />
            </div>
          )}
        </div>
      </div>
    );
  }

  private onNavigationButtonClick = (direction: 'left' | 'right') => () => {
    if (!this.listRef.current) {
      return;
    }

    const currentIndex = this.state.currentIndex + (direction === 'left' ? -1 : 1);
    const { offset, isLast } = getNextSlidePosition(this.listRef.current, currentIndex, this.state.currentIndex);

    if (currentIndex < 0 || offset === this.state.scrollLeft) {
      return;
    }

    this.setState({
      currentIndex,
      scrollLeft: offset,
      isLast,
    });
  };

  private refreshState = () => {
    const isLast = !shouldRenderSliderArrows(this.listRef.current);

    this.setState({
      ...DEFAULT_STATE,
      isLast,
    });
  };
}
